import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import vuetify from './plugins/vuetify'
import filters from './filters'
import store from './store'
import timeago from 'vue-timeago3'
import { useCookies } from 'vue3-cookies'; // Импортируем VueCookies
import Clipboard from 'v-clipboard';

const { cookies } = useCookies();
i18n.global.locale.value = cookies.get('lang') || 'en';
vuetify.locale.current = cookies.get('lang') || 'en';
document.querySelector("html").setAttribute("lang", cookies.get('lang') || 'en');

// Проверяем наличие всех необходимых куков
const accessCookie = cookies.isKey('access_id');
const sessionIdCookie = cookies.isKey('session_id');
const isAuthenticated = cookies.get('isAuthenticated') === 'true';

if (isAuthenticated && accessCookie && sessionIdCookie) {
    store.commit('SET_AUTH', true);  // Устанавливаем флаг авторизации в store
} else {
    store.commit('SET_AUTH', false);
}

const timeagoOptions = {
    converterOptions: {
        includeSeconds: true,
        addSuffix: true,
        useStrict: true,
    }
}

const app = createApp(App)
app.use(Clipboard);
app.use(router)
app.use(i18n)
app.use(vuetify)
app.use(timeago, timeagoOptions)
app.use(filters)
app.use(store)
app.mount('#app')
